export function setCookie(
  name: string,
  value: string,
  days: number | null = 15
) {
  console.log("setCookie", name, days);
  let cookieString = `${name}=${encodeURIComponent(
    value || ""
  )}; path=/; SameSite=Strict`;

  if (days !== null) {
    const maxAge = days * 24 * 60 * 60;
    cookieString += `; Max-Age=${maxAge}`;
  }

  document.cookie = cookieString;
}

export function getCookie(name: string) {
  const cookies = document.cookie.split("; ");
  for (const c of cookies) {
    const [key, valor] = c.split("=");
    if (key === name) return decodeURIComponent(valor);
  }
  return null;
}

export function deleteCookie(name: string) {
  document.cookie = name + "=; Max-Age=0; path=/";
}
